<section class="breadcrumbs_common bg_img pos_relative">
   <div class="overlay-innerpage"></div>
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-12">
            <div class="breadcrumbs_content">
               <h2 class="text-white">IQAC Members</h2>
               <ul class="breadcrumb">
                  <li>
                     <a routerLink="/">Home</a>
                  </li>/
                  <li class="active">
                     <a href="javascript:void(0);">IQAC Members</a>
                  </li>
               </ul>
            </div>
         </div>
      </div>
   </div>
</section>

<section class="minority-cell ptb--100 ">
   <div class="container">
      <div class="row justify-content-center gx-4">
         <div class="col-md-12">
            <div class="sec-title">
               <h2>IQAC Committee <span>2023-24</span></h2>
            </div>
            <div class="table-responsive mt-3">
               <table class="table table-bordered table--4">
                  <thead>
                     <tr>
                        <th>Sr. No.</th>
                        <th>Name of Member</th>
                        <th>Organization</th>
                        <th>Position</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>1</td>
                        <td>Dr. H.R.Kulkarni</td>
                        <td>Director, GHRCACS, Pune</td>
                        <td>Chairperson</td>
                     </tr>
                     <tr>
                        <td>2</td>
                        <td>Prof. Sheela Satav</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>3</td>
                        <td>Prof. Tushar Kadlag</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>4</td>
                        <td>Prof. Paramela Jogadande</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>5</td>
                        <td>Dr. Mohit Raut</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>6</td>
                        <td>Dr. Aarti Deshpande</td>
                        <td>Director, RGI</td>
                        <td>Member, Nominee From Management</td>
                     </tr>
                     <tr>
                        <td>7</td>
                        <td>Ms. Archana Shinde</td>
                        <td>Accountant, GHRCACS, Pune</td>
                        <td>Senior Administrative Member</td>
                     </tr>
                     <tr>
                        <td>8</td>
                        <td>Ms. Kiran Thakur</td>
                        <td>Student GHRCACS, Pune</td>
                        <td>Student Representative</td>
                     </tr>
                     <tr>
                        <td>9</td>
                        <td>Ms. Anjali Shivale</td>
                        <td>Alumni Student GHRCACS, Pune</td>
                        <td>Nominee Alumni</td>
                     </tr>
                     <tr>
                        <td>10</td>
                        <td>Mr. Shankar Gaikwad</td>
                        <td>Ankita Auto coaters</td>
                        <td>Industrialist</td>
                     </tr>
                     <tr>
                        <td>11</td>
                        <td>Mr. Kiran Kad</td>
                        <td>Local member</td>
                        <td>Nominee Stakeholder</td>
                     </tr>
                     <tr>
                        <td>12</td>
                        <td>Dr. Balwant Landge</td>
                        <td>HoD (Commerce Department), Bhartiya Jain Sanghatana College, Wagholi, Pune</td>
                        <td>Academician</td>
                     </tr>
                     <tr>
                        <td>13</td>
                        <td>Prof. Nilima Gaikwad</td>
                        <td>Assistant Professor, Christ College</td>
                        <td>Academician</td>
                     </tr>
                     <tr>
                        <td>14</td>
                        <td>Ms. Deepika Khandelwal</td>
                        <td>Assistant Professor, GHRCACS Pune</td>
                        <td>IQAC Coordinator</td>
                     </tr>
                  </tbody>
               </table>
            </div>
            <!-- <div class="table-responsive mt-3">
               <table class="table table-bordered table--4">
                  <thead>
                     <tr>
                        <th>Sr. No.</th>
                        <th>Name of Member</th>
                        <th>Organization</th>
                        <th>Position</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>1.</td>
                        <td>Dr. Suresh Dharane</td>
                        <td>Principal, GHRCACS, Pune</td>
                        <td>Chairperson</td>
                     </tr>
                     <tr>
                        <td>2.</td>
                        <td>Prof. Sarika Kulthe</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>3.</td>
                        <td>Prof. Prafulla Jadhav</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>4.</td>
                        <td>Prof. Paramela Jogadande</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>5.</td>
                        <td>Dr. Mohit Raut</td>
                        <td>GHRCACS, Pune</td>
                        <td>Teacher Members</td>
                     </tr>
                     <tr>
                        <td>6.</td>
                        <td>Mr. Ashwin Pande</td>
                        <td>Head HR, RGI</td>
                        <td>Member, Nominee From Management</td>
                     </tr>
                     <tr>
                        <td>7.</td>
                        <td>Ms. Archana Shinde</td>
                        <td>Accountant, GHRCACS, Pune</td>
                        <td>Senior Administrative Member</td>
                     </tr>
                     <tr>
                        <td>8.</td>
                        <td>Ms. Kiran Thakur</td>
                        <td>Student GHRCACS, Pune</td>
                        <td>Student Representative</td>
                     </tr>
                     <tr>
                        <td>9.</td>
                        <td>Ms. Anjali Shivale</td>
                        <td>Alumni Student GHRCACS, Pune.</td>
                        <td>Nominee Alumni </td>
                     </tr>
                     <tr>
                        <td>10.</td>
                        <td>Mr. Shankar Gaikwad</td>
                        <td>Ankita Auto coaters</td>
                        <td>Industrialist</td>
                     </tr>
                     <tr>
                        <td>11.</td>
                        <td>Mr. Kiran Kad</td>
                        <td>Local member</td>
                        <td>Nominee Stakeholder</td>
                     </tr>
                     <tr>
                        <td>12.</td>
                        <td>Dr. Balwant Landge</td>
                        <td>HoD (Commerce Department) Bhartiya Jain Sanghatana College, Wagholi, Pune</td>
                        <td>Academician</td>
                     </tr>
                     <tr>
                        <td>13.</td>
                        <td>Prof. Nilima Gaikwad</td>
                        <td>Assistant Professor Christ College</td>
                        <td>Academician</td>
                     </tr>
                     <tr>
                        <td>14.</td>
                        <td>Ms. Deepika Khandelwal</td>
                        <td>Assistant Professor, GHRCACS Pune</td>
                        <td>IQAC Coordinator</td>
                     </tr>
                  </tbody>
               </table>
            </div> -->
         </div>
      </div>
   </div>
</section>
